<template>
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.22152 9.47561L8.06626 3.8207L13.721 9.6875L15.5 7.96585L8.12375 0.3125L0.5 7.68909L2.22152 9.47561Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class HeadArrowUpIcon extends Vue {}
</script>
